import * as amplitude from '@amplitude/analytics-browser';
import Config from '../Config';

const config = new Config();

const accountTypes = new Map();
accountTypes.set('individual', 'individual');
accountTypes.set('jointrightsofsurvivorship', 'joint');
accountTypes.set('jointtenantsincommon', 'joint');
accountTypes.set('iratraditional', 'traditional_ira');
accountTypes.set('iraroth', 'roth_ira');
accountTypes.set('irasep', 'sep_ira');
accountTypes.set('irasimple', 'simple_ira');
accountTypes.set('entitytrust', 'trust');
accountTypes.set('entitycorporate', 'corporation');
accountTypes.set('entitypartnership', 'general_partnership');
accountTypes.set('entitylimitedliability', 'limited_liability_company');
accountTypes.set('entitysoleproprietorship', 'sole_proprietorship');

const mapAccountType = (values) => {
  let accountType = '';
  switch (values.accountType) {
    case 'joint':
      accountType = accountTypes.get(values.jointType);
      break;
    case 'entity':
      accountType = accountTypes.get(values.entityType);
      break;
    case 'ira':
      accountType = accountTypes.get(values.iraType);
      break;
    case 'individual':
      accountType = accountTypes.get(values.accountType);
      break;
    default:
      accountType = undefined;
      break;
    }
  return accountType;
};

const mapAccountType2 = (values) => {
  const accountTypeInput = values.accountType;
  const accountTypeValues = {
    accountType: values.accountType,
    jointType: null,
    entityType: null,
    iraType: null,
  };

  switch (true) {
    case /^joint/.test(accountTypeInput):
      accountTypeValues.accountType = 'joint';
      accountTypeValues.jointType = values.accountType;
      break;
    case /^entity/.test(accountTypeInput):
      accountTypeValues.accountType = 'entity';
      accountTypeValues.entityType = values.accountType;
      break;
    case /^ira/.test(accountTypeInput):
      accountTypeValues.accountType = 'ira';
      accountTypeValues.iraType = values.accountType;
      break;
    default:
      accountTypeValues.accountType = 'individual';
  }

  return mapAccountType(accountTypeValues);
};

const trackEvent = (eventName, eventProperties, fdcnId) => {
  if (config.amplitudeEnabled) {
    if (fdcnId) {
      amplitude.setUserId(fdcnId);
    }
    if (eventName === 'aop_user_registered') {
      const identifyObj = new amplitude.Identify()
        .set('country_of_residence', eventProperties.country_of_residence)
        .set('region_of_residence', eventProperties.region_of_residence);
      amplitude.identify(identifyObj);
    }
    if (eventName === 'aop_completed') {
      const identifyObj = new amplitude.Identify()
        .set('retail_client', true);
      amplitude.identify(identifyObj);
    }
    if (eventName === 'aop_personal_info_captured') {
      const identifyObj = new amplitude.Identify()
        .set('country_of_residence', eventProperties.country_of_residence)
        .set('region_of_residence', eventProperties.region_of_residence);
      amplitude.identify(identifyObj);
    }
    if (eventName === 'aop_employment_info_captured') {
      const identifyObj = new amplitude.Identify()
        .set('pro_status', eventProperties.pro_status);
      amplitude.identify(identifyObj);
    }
    if (eventName === 'aop_suitability_information_captured') {
      const identifyObj = new amplitude.Identify()
        .set('futures_experience', eventProperties.futures_experience)
        .set('income', eventProperties.income)
        .set('liquid_net_worth', eventProperties.liquid_net_worth)
        .set('total_net_worth', eventProperties.net_worth)
        .set('stocks_experience', eventProperties.stocks_experience)
        .set('options_experience', eventProperties.options_experience);
        // .set('client_level', eventProperties.client_level);
      amplitude.identify(identifyObj);
    }
    if (eventName === 'aop_equities_settings_captured') {
      const identifyObj = new amplitude.Identify()
        .set('eligible_options_level', eventProperties.eligible_options_level);
      amplitude.identify(identifyObj);
    }
    const eventPropertiesFinal = { ...eventProperties, platform: 'aop' };
    amplitude.track(eventName, eventPropertiesFinal, { user_id: fdcnId });
  }
};

export { mapAccountType, mapAccountType2, trackEvent };
